'use client';

import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { useApi } from '@/shared/hooks/use-api';

interface Test401ButtonProps {
  className?: string;
}

export const Test401Button = ({ className }: Test401ButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const api = useApi();

  const handleTest401 = async () => {
    setIsLoading(true);

    try {
      // Способ 1: Перезаписываем токен на невалидный
      const originalGet = api.get;

      // Временно подменяем метод get для добавления невалидного токена
      const testGet = (url: string, config: any = {}) => {
        return originalGet(url, {
          ...config,
          headers: {
            ...config.headers,
            Authorization: 'Bearer invalid_token_for_testing_401',
          },
        });
      };

      // Делаем запрос с невалидным токеном
      await testGet('/users/me');
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log('Тест 401: ошибка перехвачена', error);

      if (error.response?.status === 401) {
        toast({
          title: '401 ошибка успешно перехвачена!',
          description:
            'Интерцептор должен сработать и произойдет автоматический разлогин',
          // @ts-ignore
          variant: 'destructive',
        });
      } else {
        toast({
          title: 'Неожиданная ошибка',
          description: `Получен статус: ${error.response?.status || 'неизвестно'}`,
          variant: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleTest401}
      disabled={isLoading}
      className={className}
      variant="destructive"
      size="sm"
    >
      {isLoading ? 'Тестирование...' : '🧪 Тест 401'}
    </Button>
  );
};
